module.exports = __webpack_public_path__ + "img/py.13233f6.svg";